export function getImageFileDimensions(blob) {
  return new Promise(resolve => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const {height, width} = img;
      resolve({height, width});
    };
    img.src = url;
  });
}
